import React from "react";

import { ReferenceType } from "@floating-ui/react";

type DropdownAnchorChildProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onFocus: () => void;
  onBlur: () => void;
  ref: (node: ReferenceType | null) => void;
};

export type DropdownAnchorProps = Partial<Omit<DropdownAnchorChildProps, "ref">> & {
  setReference?: (node: ReferenceType | null) => void;
  children: (props: DropdownAnchorChildProps) => JSX.Element;
};

export const DropdownAnchor = ({
  children,
  setReference,
  onBlur,
  onFocus,
  setIsOpen,
}: DropdownAnchorProps) => {
  if (!setReference || !onBlur || !onFocus || !setIsOpen) {
    throw Error("DropdownAnchor should be used as direct child of Dropdown");
  }

  return children({ ref: setReference, onBlur, onFocus, setIsOpen });
};
